export interface PagingParam {
    currentPage: number;
    perPage: number;
    readonly total: number;
}

export const mergePagingParam = (src: PagingParam, newVal: Partial<PagingParam>): PagingParam => {
    return {
        currentPage: newVal.currentPage ? newVal.currentPage : src.currentPage,
        perPage: newVal.perPage ? newVal.perPage : src.perPage,
        total: newVal.total ? newVal.total : src.total,
    };
};
